export function continueToPassengerEditFromLoginOrDDSignup (): boolean {
    var selectedFareButtons = document.querySelectorAll(".ibe-radio-btn-space input:checked");

    var isRoundTrip = false;
    var isOneWay = false;
    var roundTripElement = document.getElementById('isRoundTrip');
    if (roundTripElement) {
        isRoundTrip = (roundTripElement.innerHTML === "True");
        isOneWay = (roundTripElement.innerHTML === "False");
    }
    else{
        return false;
    }

    //Validate scenarios
    if(selectedFareButtons.length === 1 && isOneWay){
        var dataset = (selectedFareButtons[0] as HTMLElement).dataset;
        var isDDFare = (dataset && (dataset["departsavings"] || dataset["returnsavings"]));
        var fareType = localStorage.getItem("fareType");
        var isNormalDDFlow = selectedFareButtons[0].attributes["isnormalddflow"].value;
        if ((isDDFare && isNormalDDFlow == 'true') || (fareType == 'DD' && isNormalDDFlow == 'false')){
            return true;
        }
        return false;

    }
    if(selectedFareButtons.length === 2 && isRoundTrip) {
        var atleastOneStandardFare = false;
        var fareType = localStorage.getItem("fareType");
        for (var i = 0; i < selectedFareButtons.length; i++) {
            var dataset = (selectedFareButtons[i] as HTMLElement).dataset;
            var isNormalDDFlow = selectedFareButtons[i].attributes["isnormalddflow"].value;
            var isDDFare = (dataset && (dataset["departsavings"] || dataset["returnsavings"]));
            if(!isDDFare) {
                atleastOneStandardFare = true;
            }
        }
        if ((isDDFare && isNormalDDFlow == "true") || (fareType == 'DD' && isNormalDDFlow == 'false')) {
            return true;
        }
        if (atleastOneStandardFare) {
            return false;
        }
    }
    return false;
}

export function isThisFlightRoundTripAndOneFareIsDiscountDenAndAnotherOneIsGoWild(): boolean {
    const selectedFareButtons = document.querySelectorAll(".ibe-radio-btn-space input:checked");
    let isRoundTrip: boolean;
    let isOneWay: boolean;
    const roundTripElement = document.getElementById('isRoundTrip');
    if (roundTripElement) {
        isRoundTrip = (roundTripElement.innerHTML === "True");
        isOneWay = (roundTripElement.innerHTML === "False");
    }
    else {
        return false;
    }

    if (selectedFareButtons.length === 1 || isOneWay) return false;

    if (selectedFareButtons.length === 2 && isRoundTrip) {
        let oneFareIsDiscountDen = false;
        let oneFareIsGoWild = false;

        for (let i = 0; i < selectedFareButtons.length; i++) {
            const dataSet = (selectedFareButtons[i] as HTMLElement).dataset;

            // Is it a DiscountDen fare?
            const isDiscountDenFare = (dataSet && (dataSet["departddonlysavings"] || dataSet["returnddonlysavings"]));
            if (isDiscountDenFare) oneFareIsDiscountDen = true;

            // Is it a GoWild fare?
            const isGoWildFare = (dataSet && (dataSet["departgowildonlysavings"] || dataSet["returngowildonlysavings"]));
            if(isGoWildFare) oneFareIsGoWild = true;
        }
        return oneFareIsDiscountDen && oneFareIsGoWild;
    }
    return false;
}
